import CryptoJS from 'crypto-js'

const encryptionKey = '(MmGPxL;UH<e]SQ|?>oK012t^?&QZCeY'

export const encryptString = (text) => {
  const encryptedText = CryptoJS.AES.encrypt(text, encryptionKey).toString()
  return encryptedText
}

export const decryptString = (result) => {
  const text = localStorage.getItem('persist')
  const bytes = CryptoJS.AES.decrypt(text, encryptionKey)
  const decryptedText = bytes.toString(CryptoJS.enc.Utf8)
  const jsonPersist = JSON.parse(decryptedText)
  return jsonPersist.user[result]
}
